import qs from "qs"

// Compares two query-param objects the way they go over the wire
// (undefined fields are dropped).
export const isSameQueryParams = (a: object, b: object) =>
  JSON.stringify(a) === JSON.stringify(b)

// Arrays go over the wire as repeated keys (`classes=1&classes=2`).
export const serializeQueryParams = (params: Record<string, unknown>) =>
  qs.stringify(params, { indices: false })
